import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import tournamentSocket from '../tournamentSocket';

export function useTournamentSocket() {
  const socketRef = useRef(tournamentSocket);
  const navigate = useNavigate();

  useEffect(() => {
    const socket = socketRef.current;

    // 1) ПОДГОТОВКА HANDSHAKE -------------------------------
    const token = localStorage.getItem('token') || '';
    const username = localStorage.getItem('username') || '';

    // ⬇⬇⬇ ГЛАВНОЕ: передаём И token, И username
    socket.auth = token
      ? { token, username } // ← ВАЖНО: username нужен серверу для комнат
      : { username };

    // (не обязательно, но полезно на этапе отладки)
    const onConnectError = (err) => {
      console.warn('[tournament] connect_error:', err?.message || err);
    };
    socket.on('connect_error', onConnectError);

    // 2) ПОДКЛЮЧАЕМСЯ ---------------------------------------
    if (!socket.connected) socket.connect();

    // 3) ДЕЙСТВИЯ СРАЗУ ПОСЛЕ CONNNECT ----------------------
    const handleConnect = () => {
      const token = localStorage.getItem('token') || '';
      const currentUser = localStorage.getItem('username') || '';

      // 👇 ВАЖНО: перед каждым подключением переустанавливаем auth
      socket.auth = token ? { token, username: currentUser } : { username: currentUser };

      // 3.1) Регистрация пользователя (один раз на коннект)
      if (currentUser) {
        socket.emit('registerUser', { userName: currentUser }, (res) => {
          console.log('[useTournamentSocket] registerUser →', res);
          socket.registered = true;
        });
      }

      // 3.2) Подтягиваем активный матч коротких (если был перезагруз)
      const gameType = localStorage.getItem('gameType');
      const tableId = Number(localStorage.getItem('tableId') || 0);

      if (gameType === 'short') {
        if (tableId) {
          // восстановление сразу в стол
          socket.emit('tournamentMatch_joinTable', { tableId, username: currentUser });
          socket.emit('fetchTournamentData', tableId);
          navigate(`/tournamentMatch/unknown?tableId=${tableId}`);
        } else {
          // спросить у сервера, не идёт ли у меня полуфинал/финал
          socket.emit('tournament_checkActiveMatch', { userName: currentUser }, (res) => {
            if (res?.inSemiFinal || res?.inFinal) {
              localStorage.setItem('tableId', String(res.tableId));
              localStorage.setItem('gameType', 'short');
              navigate(`/tournamentMatch/${res.gameId}?tableId=${res.tableId}`);
            }
          });
        }
      }

      // 3.3) Сразу запросим список турниров (без ожидания внешних триггеров)
      socket.emit('requestAllTournaments'); // ← полезно: сразу получишь карточки
    };

    // если уже подключен (быстрый F5) – делаем сразу
    if (socket.connected) {
      handleConnect();
    }

    // обычный connect
    socket.on('connect', handleConnect);

    // ⬇⬇⬇ ДОБАВЛЯЕМ: та же логика при reconnect
    socket.io?.on?.('reconnect', handleConnect);

    // 4) СЛУШАЕМ СОБЫТИЯ ЗАВЕРШЕНИЯ/ЗАКРЫТИЯ ----------------

    // a) матч закончился
    const handleGameFinished = ({ tableId }) => {
      if (String(tableId) === localStorage.getItem('tableId')) {
        localStorage.removeItem('tableId');
        localStorage.removeItem('gameType');
        console.log('[useTournamentSocket] Игра завершена, tableId очищен');
      }
    };

    // b) СТОЛ ЗАКРЫТ — ВАЖНО: имя события на сервере 'tournament_tableClosed'
    const handleTableClosed = ({ tableId }) => {
      if (String(tableId) === localStorage.getItem('tableId')) {
        localStorage.removeItem('tableId');
        localStorage.removeItem('gameType');
        console.log('[useTournamentSocket] Стол закрыт, tableId очищен');
      }
    };

    socket.on('tournamentMatch_gameFinished', handleGameFinished);
    socket.on('tournament_tableClosed', handleTableClosed); // ← ВАЖНО: правильное имя

    // 5) ПРИГЛАШЕНИЕ В СТОЛ (полуфинал/финал) ----------------
    const handleInvite = ({ tableId, color }) => {
      const u = localStorage.getItem('username') || '';
      if (!u || !tableId) return;

      localStorage.setItem('tableId', String(tableId));
      localStorage.setItem('gameType', 'short');

      socket.emit('tournamentMatch_joinTable', { tableId, username: u });
      socket.emit('fetchTournamentData', tableId);
      navigate(`/tournamentMatch/${tableId}?tableId=${tableId}&color=${color}`);
    };
    socket.on('tournament_table', handleInvite);

    // 6) ОЧИСТКА ------------------------------------------------
    return () => {
      socket.off('connect', handleConnect);
      socket.off('connect_error', onConnectError);
      socket.off('tournamentMatch_gameFinished', handleGameFinished);
      socket.off('tournament_tableClosed', handleTableClosed);
      socket.off('tournament_table', handleInvite);
      // 👇 снимаем обработчик реконнекта
      socket.io?.off?.('reconnect', handleConnect);
    };
  }, [navigate]);

  return socketRef.current;
}









// import { useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import tournamentSocket from '../tournamentSocket';

// export function useTournamentSocket() {
//   const socketRef = useRef(tournamentSocket);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const socket = socketRef.current;

//     // 1) ПОДГОТОВКА HANDSHAKE -------------------------------
//     const token = localStorage.getItem('token') || '';
//     const username = localStorage.getItem('username') || '';

//     // ⬇⬇⬇ ГЛАВНОЕ: передаём И token, И username
//     socket.auth = token
//       ? { token, username }         // ← ВАЖНО: username нужен серверу для комнат
//       : { username };

//     // (не обязательно, но полезно на этапе отладки)
//     const onConnectError = (err) => {
//       console.warn('[tournament] connect_error:', err?.message || err);
//     };
//     socket.on('connect_error', onConnectError);

//     // 2) ПОДКЛЮЧАЕМСЯ ---------------------------------------
//     if (!socket.connected) socket.connect();

//     // 3) ДЕЙСТВИЯ СРАЗУ ПОСЛЕ CONNNECT ----------------------
//    const handleConnect = () => {
//   const token = localStorage.getItem('token') || '';
//   const currentUser = localStorage.getItem('username') || '';

//   // 👇 ВАЖНО: перед каждым подключением переустанавливаем auth
//   socket.auth = token ? { token, username: currentUser } : { username: currentUser };

//       // 3.1) Регистрация пользователя (один раз на коннект)
//       if (currentUser) {
//         socket.emit('registerUser', { userName: currentUser }, (res) => {
//           console.log('[useTournamentSocket] registerUser →', res);
//           socket.registered = true;
//         });
//       }

//       // 3.2) Подтягиваем активный матч коротких (если был перезагруз)
//       const gameType = localStorage.getItem('gameType');
//       const tableId  = Number(localStorage.getItem('tableId') || 0);

//       if (gameType === 'short') {
//         if (tableId) {
//           // восстановление сразу в стол
//           socket.emit('tournamentMatch_joinTable', { tableId, username: currentUser });
//           socket.emit('fetchTournamentData', tableId);
//           navigate(`/tournamentMatch/unknown?tableId=${tableId}`);
//         } else {
//           // спросить у сервера, не идёт ли у меня полуфинал/финал
//           socket.emit('tournament_checkActiveMatch', { userName: currentUser }, (res) => {
//             if (res?.inSemiFinal || res?.inFinal) {
//               localStorage.setItem('tableId', String(res.tableId));
//               localStorage.setItem('gameType', 'short');
//               navigate(`/tournamentMatch/${res.gameId}?tableId=${res.tableId}`);
//             }
//           });
//         }
//       }

//       // 3.3) Сразу запросим список турниров (без ожидания внешних триггеров)
//       socket.emit('requestAllTournaments');     // ← полезно: сразу получишь карточки
//     };

//     // socket.connected ? handleConnect() : socket.once('connect', handleConnect);
//  if (socket.connected) {
//       // если сокет уже успел подключиться (быстрый F5) – делаем сразу
//       handleConnect();
//     }

//      socket.on('connect', handleConnect);
//     // 4) СЛУШАЕМ СОБЫТИЯ ЗАВЕРШЕНИЯ/ЗАКРЫТИЯ ----------------

//     // a) матч закончился
//     const handleGameFinished = ({ tableId }) => {
//       if (String(tableId) === localStorage.getItem('tableId')) {
//         localStorage.removeItem('tableId');
//         localStorage.removeItem('gameType');
//         console.log('[useTournamentSocket] Игра завершена, tableId очищен');
//       }
//     };

//     // b) СТОЛ ЗАКРЫТ — ВАЖНО: имя события на сервере 'tournament_tableClosed'
//     // у тебя стояло 'tournamentMatch_tableClosed' — это не прилетит.
//     const handleTableClosed = ({ tableId }) => {
//       if (String(tableId) === localStorage.getItem('tableId')) {
//         localStorage.removeItem('tableId');
//         localStorage.removeItem('gameType');
//         console.log('[useTournamentSocket] Стол закрыт, tableId очищен');
//       }
//     };

//     socket.on('tournamentMatch_gameFinished', handleGameFinished);
//     socket.on('tournament_tableClosed', handleTableClosed); // ← ВАЖНО: правильное имя

//     // 5) ПРИГЛАШЕНИЕ В СТОЛ (полуфинал/финал) ----------------
//     const handleInvite = ({ tableId, color }) => {
//       const u = localStorage.getItem('username') || '';
//       if (!u || !tableId) return;

//       localStorage.setItem('tableId', String(tableId));
//       localStorage.setItem('gameType', 'short');

//       socket.emit('tournamentMatch_joinTable', { tableId, username: u });
//       socket.emit('fetchTournamentData', tableId);
//       navigate(`/tournamentMatch/${tableId}?tableId=${tableId}&color=${color}`);
//     };
//     socket.on('tournament_table', handleInvite);

//     // 6) ОЧИСТКА ------------------------------------------------
//     return () => {
//       socket.off('connect', handleConnect);
//       socket.off('connect_error', onConnectError);
//       socket.off('tournamentMatch_gameFinished', handleGameFinished);
//       socket.off('tournament_tableClosed', handleTableClosed);
//       socket.off('tournament_table', handleInvite);
//     };
//   }, [navigate]);

//   return socketRef.current;
// }






// import { useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import tournamentSocket from '../tournamentSocket'; // ✅ default импорт

// export function useTournamentSocket() {
//   const socketRef = useRef(tournamentSocket);
//   const navigate  = useNavigate();

//   useEffect(() => {
//     const socket   = socketRef.current;
//     const username = localStorage.getItem('username') || '';

//     /* ---------- 1. регистрация и checkActiveMatch ОДИН раз ---------- */
//     const handleConnect = () => {
//       if (username)
//         socket.emit('registerUser', { userName: username });

//       const cachedTable = Number(localStorage.getItem('tableId') || 0);
//       if (cachedTable) {
//         socket.emit('tournamentMatch_joinTable', { tableId: cachedTable, username });
//         socket.emit('fetchTournamentData',        cachedTable);
//       } else if (username) {
//         socket.emit('tournament_checkActiveMatch', { userName: username }, (res) => {
//           if (res?.inSemiFinal || res?.inFinal) {
//             localStorage.setItem('tableId',  String(res.tableId));
//             localStorage.setItem('gameType', 'short');
//             navigate(`/tournamentMatch/${res.gameId}?tableId=${res.tableId}`);
//           }
//         });
//       }
//     };

//     if (socket.connected) handleConnect();
//     else                  socket.once('connect', handleConnect);
//     socket.connect();

//     /* ---------- 2. глобальный приём инвайтов  ---------- */
//     const handleInvite = ({ tableId, color }) => {
//       if (!tableId || !username) return;

//       localStorage.setItem('tableId',  String(tableId));
//       localStorage.setItem('gameType', 'short');

//       socket.emit('tournamentMatch_joinTable', { tableId, username });
//       socket.emit('fetchTournamentData',        tableId);

//       navigate(`/tournamentMatch/${tableId}?tableId=${tableId}&color=${color}`);
//     };

//     socket.on('tournament_table', handleInvite);

//     return () => {
//       socket.off('connect',          handleConnect);
//       socket.off('tournament_table', handleInvite);
//     };
//   }, []);

//   return socketRef.current;
// }
 












// // hooks/useTournamentSocket.ts
// import { useEffect, useRef } from 'react';
// import tournamentSocket from '../tournamentSocket';

// export function useTournamentSocket() {
//   const socketRef = useRef(tournamentSocket);

//   useEffect(() => {
//     const socket   = socketRef.current;
//     const username = localStorage.getItem('username') || '';
//     const tableId  = localStorage.getItem('tableId');

//     /* 1‑а. Передаём имя пользователя */
//     if (username) socket.auth = { username };

//   const handleConnect = () => {
//   socket.emit('registerUser', { username });

//   if (tableId) {
//     socket.emit('tournamentMatch_joinTable', {
//       tableId: Number(tableId),
//       username,
//     });

//     socket.emit('fetchTournamentData', Number(tableId));
//   } else if (username) {
//     // 1‑д. Если нет tableId — проверим, участвует ли игрок в полуфинале/финале
//     socket.emit('tournament_checkActiveMatch', { userName: username }, (res) => {
//       if (res?.gameStatus === 'finished') return;
//       if (!(res?.inSemiFinal || res?.inFinal)) return;

//       const routeBase = res.gameType === 'long' ? 'longTournamentMatch' : 'tournamentMatch';
//       window.location.href = `/${routeBase}/${res.gameId}?tableId=${res.tableId}`;
//     });
//   }
// };


//     if (socket.connected) {
//       handleConnect();
//     } else if (!socket.connecting) {
//   socket.once('connect', handleConnect);
//   socket.connect();
// }

//     return () => {
//       socket.off('connect', handleConnect);
//     };
//   }, []);

//   return socketRef.current;
// }


















// // hooks/useTournamentSocket.ts
// import { useEffect, useRef } from 'react';
// import tournamentSocket from '../tournamentSocket';
// export function useTournamentSocket() {
//   const socketRef = useRef(tournamentSocket);

//   useEffect(() => {
//     const socket   = socketRef.current;
//     const username = localStorage.getItem('username') || '';
//     const tableId  = localStorage.getItem('tableId');

//     /* 1‑а.  Передавайте то же имя поля, которое сервер ждёт ─ `username`  */
//     if (username) socket.auth = { username };   // было { userName }

//     const handleConnect = () => {
//       /* 1‑б.  Регистрация в «личной» комнате */
//       socket.emit('registerUser', { username });

//       /* 1‑в.  Автовход за стол после F5 */
//       if (tableId) {
//         socket.emit('tournamentMatch_joinTable', {
//           tableId: Number(tableId),
//           username,
//         });
//       }
//  socket.emit('fetchTournamentData', Number(tableId));
//       /* 1‑г.  А вдруг мы уже в полу/финале? */
//       socket.emit('tournament_checkActiveMatch', { username });
//     };

//     /* ------------------------------- */
//     /* ГЛАВНЫЙ ФИКС                     */
//     /* ------------------------------- */
//     if (socket.connected) {
//       /* ✅  сокет уже открыт → вызываем сами  */
//       handleConnect();
//     } else {
//       /* ⏳  ещё не подключился → ждём `connect` */
//       socket.once('connect', handleConnect);
//       socket.connect();
//     }

//     return () => socket.off('connect', handleConnect);
//   }, []);

//   return socketRef.current;
// }
 





// // hooks/useTournamentSocket.ts
// import { useEffect, useRef } from 'react';
// import tournamentSocket from '../tournamentSocket';

// export function useTournamentSocket() {
//   const socketRef = useRef(tournamentSocket);

//   useEffect(() => {
//     const socket    = socketRef.current;
//     const userName  = localStorage.getItem('username');

//     /* 1. передаём имя в handshake ‑ это нужно для server‑side auto‑join   */
//     if (userName) {
//       socket.auth = { userName };
//     }

//     /* 2. объявляем handler ДО подключения */
//     const handleConnect = () => {
//       if (userName) {
//         // войти в личную комнату
//         socket.emit('registerUser', { userName });

//         // сразу спросить «а не иду ли я уже в полу/финале?»
//         socket.emit('tournament_checkActiveMatch', { userName });
//       }
//     };
//     socket.on('connect', handleConnect);

//     /* 3. подключаемся ТОЛЬКО после того, как подписались на 'connect'     */
//     if (!socket.connected) {
//       socket.connect();
//     } else {
//       // страница перерисовывалась, но сокет уже был открыт
//       handleConnect();
//     }

//     return () => {
//       socket.off('connect', handleConnect);   // отписка
//       /* ! НЕ вызываем socket.disconnect() — иначе порвём комнаты у всех */
//     };
//   }, []);

//   return socketRef.current;
// }





// import { useEffect, useRef } from 'react';
// import { io } from 'socket.io-client';

// export function useTournamentSocket() {
//   const socketRef = useRef(null);

//   if (!socketRef.current) {
//     const API_URL = process.env.REACT_APP_API_URL;
//     const PORT = process.env.REACT_APP_PORT;
//     const socketUrl = `http://${API_URL}:${PORT}`;

//     socketRef.current = io(`${socketUrl}/tournament`, { autoConnect: false });

//     socketRef.current.on('spinWheel', (data) => {
//       console.log('[useTournamentSocket] spinWheel', data);
//     });

//     socketRef.current.on('connect', () => {
//       const userName = localStorage.getItem('username');
//       if (userName) {
//         socketRef.current.emit('registerUser', { userName });
//         socketRef.current.emit('tournament_checkActiveMatch', { userName }, () => {});
//       }
//     });
//   }

//   useEffect(() => {
//     socketRef.current.connect();
//     return () => {
//       socketRef.current.off(); // НЕ disconnect!
//     };
//   }, []);

//   return socketRef.current;
// }
